var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: _vm.id + "_wrapper" } },
    [
      _c("multiselect", {
        ref: "multiselect",
        attrs: {
          id: _vm.id,
          "track-by": _vm.trackBy,
          label: "name",
          options: _vm.items,
          multiple: _vm.multiple,
          placeholder: _vm.placeholder,
          selectLabel: "",
          selectedLabel: "",
          deselectLabel: "",
          openDirection: "bottom",
          searchable: _vm.searchable,
          closeOnSelect: _vm.multiple ? false : true,
          allowEmpty: _vm.allowEmpty,
          "aria-labelledby": _vm.id + "_label",
        },
        on: { input: _vm.onSelected },
        scopedSlots: _vm._u(
          [
            {
              key: "singleLabel",
              fn: function ({ option }) {
                return [
                  _vm._t(
                    "singleLabel",
                    function () {
                      return [_c("strong", [_vm._v(_vm._s(option.name))])]
                    },
                    { option: option }
                  ),
                ]
              },
            },
            {
              key: "option",
              fn: function ({ option }) {
                return [
                  _vm._t(
                    "option",
                    function () {
                      return [_vm._v(_vm._s(option.name))]
                    },
                    { option: option }
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedObjects,
          callback: function ($$v) {
            _vm.selectedObjects = $$v
          },
          expression: "selectedObjects",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }